import React, { type FC } from 'react';
import clsx from 'clsx';
import { FlexBox } from '@is24at/react-ui-core';
import { type Listing } from 'server/types/graphql';
import Property from '../Property';
import styles from './Section.scss';

type SectionProps = {
  hits: Listing[];
  isLoading?: boolean;
  title?: string;
  baseUrl: string;
  moreBtnProps: {
    label: string;
    url: string;
  };
  companyName: string;
};

const Section: FC<SectionProps> = ({
  hits,
  isLoading,
  title,
  baseUrl,
  moreBtnProps,
  companyName,
}) => {
  return (
    <>
      {title && <div className={styles['section-header']}>{title}</div>}
      {!!hits?.length && (
        <div
          className={clsx(
            styles.section,
            isLoading && styles['section--loading'],
          )}
        >
          {hits.map((entry: Listing) => (
            <Property
              key={entry?.exposeId}
              baseUrl={baseUrl}
              companyName={companyName}
              {...entry}
            />
          ))}
        </div>
      )}
      <FlexBox tag="a" className={styles.btn} href={moreBtnProps.url}>
        {moreBtnProps.label}
      </FlexBox>
    </>
  );
};

export default Section;
